import React from 'react'
import { Icon, IconProps } from '@chakra-ui/react'

export const ImageIcon = (props: IconProps) => {
  return (
    <Icon viewBox='0 0 700 300' {...props}>
      <g>
        <path d='m453.66 110.77h-201.6c-37.07 0-67.199 30.129-67.199 67.199v201.6c0 3.0234 0.28125 5.9922 0.67188 8.9023 0.054687 0.22266 0.054687 0.50391 0.11328 0.72656 4.7031 32.48 32.648 57.566 66.414 57.566h201.6c37.07 0 67.199-30.129 67.199-67.199v-201.6c0-37.07-30.129-67.195-67.199-67.195zm-201.6 22.398h201.6c24.695 0 44.801 20.105 44.801 44.801v138.32l-43.121-43.121c-8.7344-8.6797-22.961-8.625-31.641 0.054687l-87.695 87.586-48.832-48.832c-8.457-8.457-23.184-8.457-31.641 0l-48.328 48.328v-182.34c0.058593-24.695 20.16-44.801 44.855-44.801zm201.6 291.2h-201.6c-20.887 0-38.473-14.391-43.398-33.824l62.664-62.719 48.832 48.832c8.7344 8.7344 22.961 8.7344 31.695 0l87.695-87.641 58.91 58.91v31.586c0.003906 24.754-20.102 44.855-44.797 44.855zm-204.68-231.39c0-12.375 10.023-22.398 22.398-22.398s22.398 10.023 22.398 22.398-10.023 22.398-22.398 22.398-22.398-10.023-22.398-22.398z' />
      </g>
    </Icon>
  )
}
